import React, { useEffect, useRef } from 'react';
import '../styles/Announcements.css';
import { useTranslation } from 'react-i18next';

const Announcements = () => {
  const announcementsSectionRef = useRef(null);
  const { t } = useTranslation();

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      { threshold: 0.1 }
    );

    if (announcementsSectionRef.current) {
      observer.observe(announcementsSectionRef.current);
    }

    return () => {
      if (observer) {
        observer.disconnect();
      }
    };
  }, []);

  return (
    <div className="announcements-section" ref={announcementsSectionRef}>
      <h2>{t('announcements.title')} <span className="gradient-text">{t('announcements.highlight')}</span></h2>
      <div className="announcements-container">
        <div className="announcement-card">
          <div className="announcement-date">{t('announcements.card0.date')}</div>
          <h3>{t('announcements.card0.title')}</h3>
          <p>
            {t('announcements.card0.content')}
          </p>
          <a href="#/article/open-source-models" className="read-more">{t('announcements.readMore')} →</a>
        </div>
        
        <div className="announcement-card">
          <div className="announcement-date">{t('announcements.card1.date')}</div>
          <h3>{t('announcements.card1.title')}</h3>
          <p>
            {t('announcements.card1.content')}
          </p>
          <a href="#/article/public-announcement" className="read-more">{t('announcements.readMore')} →</a>
        </div>
        
        <div className="announcement-card">
          <div className="announcement-date">{t('announcements.card2.date')}</div>
          <h3>{t('announcements.card2.title')}</h3>
          <p>
            {t('announcements.card2.content')}
          </p>
          <a href="#/article/ampyfin-v4-release" className="read-more">{t('announcements.readMore')} →</a>
        </div>
        
        <div className="announcement-card">
          <div className="announcement-date">{t('announcements.card3.date')}</div>
          <h3>{t('announcements.card3.title')}</h3>
          <p>
            {t('announcements.card3.content')}
          </p>
          <a href="#/article/ampyfin-v3-release" className="read-more">{t('announcements.readMore')} →</a>
        </div>
        
        <div className="announcement-card">
          <div className="announcement-date">{t('announcements.card4.date')}</div>
          <h3>{t('announcements.card4.title')}</h3>
          <p>
            {t('announcements.card4.content')}
          </p>
          <a href="#/article/ampyfin-v2-release" className="read-more">{t('announcements.readMore')} →</a>
        </div>
        
        <div className="announcement-card">
          <div className="announcement-date">{t('announcements.card5.date')}</div>
          <h3>{t('announcements.card5.title')}</h3>
          <p>
            {t('announcements.card5.content')}
          </p>
          <a href="#/article/ampyfin-v1-release" className="read-more">{t('announcements.readMore')} →</a>
        </div>
      </div>
    </div>
  );
};

export default Announcements; 